import * as React from 'react'
export const Gy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" width="1em" height="1em" {...props}>
    <path fill="#009E49" d="M0 0h900v600H0z" />
    <path fill="#FFF" d="m0 0 947 300L0 600z" />
    <path fill="#FFD00D" d="M0 26.1 870 300 0 573.9z" />
    <path fill="#2D2D2D" d="m0 0 450 300L0 600z" />
    <path fill="#D3132F" d="m0 35 397.5 265L0 565z" />
  </svg>
)
